<template>
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <c-tab
        :dense="true"
        type="pagetop"
        :tabItems.sync="tabItems"
        :inlineLabel="true"
        setHeight="500px"
        v-model="tab"
      >
        <template v-slot:default="tab">
          <component
            dense
            :is="tab.component"
          />
        </template>
      </c-tab>
    </div>
  </div>
</template>
<script>
export default {
  name: 'local-exhaust-system-plan-tab',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
      }),
    },
  },
  data() {
    return {
      tab: 'localExhaustSystemPlanInfo',
      tabItems: [],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.tabItems = [
        // 기본정보
        { name: 'localExhaustSystemPlanInfo', icon: 'info', label: 'LBL0010566', component: () => import(`${'./localExhaustSystemPlanInfo.vue'}`) }, // 국소배기장치 설치계획
        // 도면
        { name: 'localExhaustSystemPlanPid', icon: 'tab', label: 'LBL0010567', component: () => import(`${'./localExhaustSystemPlanPid.vue'}`) }, // 국소배기장치 설치계획도
        // 문서
        { name: 'localExhaustSystemPlanDoc', icon: 'assignment', label: 'LBL0010568', component: () => import(`${'./localExhaustSystemPlanDoc.vue'}`) } // 국소배기장치 설치계획 문서
      ]
    },

  }
};
</script>